import { isBefore } from 'date-fns'
import { parseDate } from '../parseDate'
import { isSameDays } from '../isSameDays'
import { startOfDay } from '../startOfDay'

const isBeforeDate = (dateString: string, compareDateString: string): boolean => {
  const date = parseDate(startOfDay(dateString))
  const compareDate = parseDate(startOfDay(compareDateString))
  if (!date || !compareDate) {
    throw new Error('Invalid date string')
  }
  return isBefore(date, compareDate)
}

export const isDateRange = (
  startDateString: string,
  endDateString: string,
  allowSameDate: boolean = false,
): boolean => {
  return isBeforeDate(startDateString, endDateString) || (allowSameDate && isSameDays(startDateString, endDateString))
}
